export default __webpack_public_path__ + "static/media/pakistan3.7959f76e.jpg";